/* eslint-disable jsx-a11y/label-has-associated-control */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShareIcon from '@mui/icons-material/Share';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import copy from 'copy-to-clipboard';
import React, { useEffect, useRef, useState } from 'react';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { getFromLocalStorage } from '../../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../../components/helper/axiosHelper';
import { defaultImage } from '../../../../constants';
import { PageHitCountApi } from '../../../../shared/Helper';

const PublicProfile = () => {
  const { referralLink, pid } = useParams();
  const isActive = useSelector((state) => state.toggle.isActive);

  const [campaignApiData, setCampaignAPIData] = useState([]);
  const [userdata, setuserdata] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [epUserID, setEpUserID] = useState(null);

  const { t } = useTranslation();
  const hasMounted = useRef(false);
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    if (!hasMounted.current) {
      getCampaigns();
      getUserData();
      hitCount();
      hasMounted.current = true;
    }
  }, []);

  useEffect(() => {
    // localStorage.setItem('isHome', false);

    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    if (epUserID !== null) {
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const hitCount = async () => {
    await postAsync('Utilities/ViewHitAPI', {}, { processID: pid, projectID: referralLink })
      .then((response) => {
        const result = response?.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  const getCampaigns = async () => {
    setIsLoading(true);
    await getAsync('Campaign/GetCampaignListByEpUserProfileLink', { referralLink: referralLink })
      .then((response) => {
        setIsLoading(false);
        const result = response?.data;
        setCampaignAPIData(result);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getUserData = async () => {
    await getAsync(`EP_UserAuthentication/GetEPUserByProfileLink`, { referralLink: referralLink }).then((response) => {
      const result = response?.data[0];
      setuserdata(result);
    });
  };

  const handleShareLink = (guid) => {
    const shareLink = `${reactURL}/CampaignRefferral/` + guid + '/' + 2;
    copy(shareLink);
    toast.success(t('Link copy Successfully'));
  };
  return (
    <div className="">
      <div className="container-fluid pt-20  sm:pt-20 xl:pt-36">
        <div className="row lg:px-5">
          <div className="col-lg-12 ">
            <h1 className="sm:text-3xl text-center text-customgreen font-medium">{t('User Profile')}</h1>

            <div className="row justify-center mx-2">
              <div className="w-full max-w-sm mt-2  bg-green-50 text-center  border border-gray-200 rounded-lg shadow ">
                <h2 className="sm:text-2xl text-center text-customgreen font-semibold my-3">{t('User Name')}</h2>
                <div className="flex flex-col items-center pb-2">
                  <input
                    type="text"
                    name="username"
                    disabled
                    style={{ width: '200px' }}
                    className=" border border-gray-300 text-gray-900 text-center text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 "
                    value={userdata?.fullName}
                  />
                </div>
                <div className="flex flex-col items-center pb-10">
                  {userdata?.doc ? (
                    <img
                      className="w-24 h-24 mb-3 rounded-full shadow-lg"
                      src={`data:image/png;base64,${userdata.doc}`}
                      alt="userProfile.png"
                    />
                  ) : (
                    <div
                 
                    className="w-24 cursor-pointer h-24 mb-3 flex items-center justify-center rounded-full border-2 border-customgreen"
                  >
                    <svg
                      version="1.0"
                      xmlns="http://www.w3.org/2000/svg"
                      width="50.000000pt"
                      height="50.000000pt"
                      viewBox="0 0 290.000000 350.000000"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <g
                        transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                        fill="#057A55"
                        stroke="none"
                      >
                        <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />
                        <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />
                      </g>
                    </svg>
                   
                  </div>
                  )}
                </div>
              </div>
            </div>

            <br />
            <br />

            <Accordion className="mb-5">
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <h1
                  className="text-center font-semibold text-customgreen"
                  style={{ fontFamily: 'SomarRounded, sans-serif' }}
                >
                  {t('Campaigns')}
                </h1>
              </AccordionSummary>

              <AccordionDetails>
                {/* <h1 className='text-center font-semibold text-customgreen'>Campaigns</h1> */}
                <div className="rounded-lg container-fluid border-2 border-customgreen">
                  <div className="row mt-5 justify-content-center align-middle">
                    {isLoading ? (
                      <LoadingAnimation />
                    ) : (
                      campaignApiData?.map((data) => (
                        <div className=" col-sm-12 col-md-6 col-lg-3">
                          <div className="shadow p-3 mb-5 justify-center sm:h-80 text-center bg-white border-gray-200 rounded-3xl shadow  px-3 hover:scale-105 transition-transform duration-300 ">
                            <Card.Body>
                              {/* <Card.Title className="text-customgreen my-2"> */}
                              {/* {data?.campaignName ? data?.campaignName : 'Build Mosque'} */}
                              {/* </Card.Title> */}

                              <div className={`flex justify-between text-center  ${isActive ? 'pl-12' : 'pr-12'}`}>
                                <ShareIcon
                                  onClick={() => handleShareLink(data?.campaignLink)}
                                  className={`w-7 h-7 items-center cursor-pointer  text-customgreen  m-3 ${isActive ? 'rotate-180' : ''}    `}
                                />
                                <div className={`flex   justify-center items-center  w-full `}>
                                  <h3 className="capitalize truncate text-wrap font-semibold text-customgreen">
                                    {data?.campaignName ? data?.campaignName : 'Build Mosque'}
                                  </h3>
                                </div>
                              </div>

                              {/* <Card.Text>{ data?.campaignID }</Card.Text> */}
                            </Card.Body>
                            <div className="cardImg justify-center items-center flex w-full">
                              <img
                                className="img flex justify-center"
                                src={`data:image/jpeg;base64,${data?.campaignImage ? data?.campaignImage : defaultImage}`}
                              />
                            </div>
                            <Link to={`/ProjectList/${data?.campaignLink}/${2}`}>
                              <Button className="focus:outline-none text-white mt-4 rounded-full bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen font-medium text-sm px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen">
                                {t('Select')}
                              </Button>
                            </Link>
                          </div>
                        </div>
                      ))
                    )}{' '}
                    {datanotfound && <DataNotFound />}
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicProfile;
